<template>
    <div>
        <h1 class="tw-py-7 tw-w-full tw-text-2xl sm:tw-text-3xl sm:tw-text-5xl lg:tw-text-7xl tw-leading-none tw-uppercase">
            INTERNATIONAL
            <br>CINEMATOGRAPHERS
            <br>GUILD
        </h1>

        <home-carousel
            ref="carousel_top_section"
            :carousel="carouselsProp?.HOME_TOP_SECTION"
        >
        </home-carousel>

        <!-- Story and values -->

        <div class="tw-flex tw-flex-col md:tw-flex-row tw-py-12">
            <div class="h7 tw-pb-3 tw-w-full lg:tw-w-2/6 xl:tw-w-1/6">
                Story and Values
            </div>
            <div class="tw-w-full sm:tw-w-4/6">
                <p class="tw-text-xl md:tw-text-3xl tw-font-light tw-pb-4 tw-pr-2 xl:tw-pr-16">
                    {{ $root.sanitizeAndTruncateHTML(contents.about_us.body, 400) }}
                </p>
                <span @click="$inertia.visit(route('about-us.index'))" class="tw-flex tw-flex-row tw-gap-2 ">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 29 26">
                        <path id="Path_1015" data-name="Path 1015" d="M12.835,29,26,0A63.8,63.8,0,0,1,0,0C5.536,11.253,12.835,29,12.835,29Z" transform="translate(0 26) rotate(-90)"/>
                    </svg>
                    <span class="h7 tw-uppercase text-link" @click="$inertia.visit(route('about-us.index'))">About Us</span>
                </span>
            </div>
        </div>

        <hr class="tw--mx-2 md:tw--mx-0">

        <!-- Whats New -->
        <div class="tw-flex tw-flex-row tw-justify-between tw-pt-7 tw-pb-3 lg:tw-pb-7">
            <div class="h7">What's new</div>
            <a :href="route('news-and-events.index')" class="tw-flex tw-flex-row tw-justify-end tw-items-center tw-gap-2 ">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 29 26">
                    <path id="Path_1015" data-name="Path 1015" d="M12.835,29,26,0A63.8,63.8,0,0,1,0,0C5.536,11.253,12.835,29,12.835,29Z" transform="translate(0 26) rotate(-90)"/>
                </svg>
                <span class="h7 tw-uppercase text-link">News & Events</span>
            </a>
        </div>
        <div class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-gap-2 tw-mb-12"
             v-if="eventsProp[0]"
        >
            <HomeNewsArticle
                v-if="eventsProp[0]"
                :image="eventsProp[0].image"
                :title="eventsProp[0].title"
                :date="eventsProp[0].date"
                :content="eventsProp[0].content"
                :link="route('news-and-events.show', eventsProp[0].id)"
            />
            <hr class="sm:tw-hidden tw-mt-7 tw-mb-5 tw--mx-2 md:tw--mx-0" />
            <div class="tw-hidden md:tw-flex tw-w-px tw-border-r tw-border-gray-700 tw-mx-2"></div>
            <HomeNewsArticle
                v-if="eventsProp[1]"
                :image="eventsProp[1].image"
                :title="eventsProp[1].title"
                :date="eventsProp[1].date"
                :content="eventsProp[1].content"
                :link="route('news-and-events.show', eventsProp[1].id)"
            />
        </div>

        <hr class="tw--mx-2 md:tw--mx-0">

        <!-- Desktop Menu -->
        <div class="tw-hidden sm:tw-flex tw-flex-row tw-items-center tw-justify-between tw-py-7">
            <div class="h7">Latest Shows</div>
            <div class="tw-flex tw-flex-row tw-justify-end tw-gap-12">
                <OutlineArrows @click="goPrev" :flip="true" />
                <OutlineArrows @click="goNext" />
            </div>
        </div>
        <!-- Mobile Menu -->
        <div class="tw-flex sm:tw-hidden tw-px-4 tw-pt-5 tw-pb-7 tw-flex-row tw-justify-between tw-items-center">
            <SolidBlackArrows @click="goPrev" :flip="true" />
            <h6 class="tw-text-xs tw-uppercase">Latest Shows</h6>
            <SolidBlackArrows @click="goNext" />
        </div>
        <h2 class="tw-hidden sm:tw-flex tw-uppercase tw-leading-none tw-pb-5">
            <ActionArrow class="tw-mr-2" />
            <div class="current_show_title" ref="currentShowTitle"></div>
        </h2>
        <div class="splideContainer">
            <Splide
                class="tw-pb-12"
                ref="splide1"
                :options="splide_options"
            >
                <SplideSlide
                    v-for="(show, index) in showsProp"
                    :key="index"
                >
                    <a
                        :href="show.link"
                        target="_blank"
                    >
                        <img
                            class="carousel-image"
                            :src="'/storage/shows/'+show.image"
                            :alt="show.title"
                        />
                    </a>
                </SplideSlide>

            </Splide>
        </div>
        <hr class="tw--mx-2 md:tw--mx-0">
        <div class="tw-flex tw-flex-col sm:tw-flex-row tw-pt-7">
            <div class="h7 tw-w-2/6 xl:tw-w-1/6 tw-pb-3 sm:pb-0">WEBSITES</div>
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-3/6 websites-section tw-pb-4 tw-pl-10 sm:tw-pl-0 tw-pr-0 sm:tw-pr-16 tw-gap-3">
                <a href="https://www.ia667dp.com/" class="text-link" target="_blank" @mouseover="changeSrc('https://www.ia667dp.com/')">667 DP</a>
                <a href="https://ia667stills.com/" class="text-link" target="_blank" @mouseover="changeSrc('https://ia667stills.com/')">667 STILLS</a>
                <!-- Uncomment and remove the under construction one once the publicists website will be working. -->
                <!--<a href="https://ia667publicists.com/" class="text-link" target="_blank" @mouseover="changeSrc('https://ia667publicists.com/')">667 PUBLICISTS</a>-->
                <a @click="underConstruction" class="text-link" @mouseover="changeSrc('under_construction')">667 PUBLICISTS</a>
                <a href="https://iatse671.wordpress.com/" class="text-link" target="_blank" @mouseover="changeSrc('https://iatse671.wordpress.com/')">IATSE 671</a>
                <a href="https://canada.iatse.net/" target="_blank" class="text-link" @mouseover="changeSrc('https://canada.iatse.net/')">IATSE CANADA</a>
                <a href="https://iatse.net/" target="_blank" class="text-link" @mouseover="changeSrc('https://iatse.net/')">IATSE INTL</a>
            </div>
            <link-preview-component
                v-show="currentSrc"
                :src="currentSrc"
                style="width:456px; height: 312px;"
                @close-modal="dialog = false"
            ></link-preview-component>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import LinkPreviewComponent from '@/Generic/LinkPreviewComponent'
import HomeNewsArticle from '@/Pages/ExternalPages/components/HomeNewsArticle'
import HomeCarousel from '@/Pages/ExternalPages/components/HomeCarousel.vue'
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import SolidGreenArrows from "@/Generic/icons/SolidGreenArrows";
import OutlineArrows from "@/Generic/icons/OutlineArrows";
import ActionArrow from "@/Generic/icons/ActionArrow";
import SolidBlackArrows from "@/Generic/icons/SolidBlackArrows";

export default {
    name: "HomeIndex",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
        SolidBlackArrows,
        LinkPreviewComponent,
        HomeNewsArticle,
        HomeCarousel,
        Splide,
        SplideSlide,
        SolidGreenArrows,
        OutlineArrows,
        ActionArrow
    },
    props: {
        'carouselsProp': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'eventsProp': {
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
        'showsProp': {
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
        'contents': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            dialog: false,
            currentSrc: "",
        }
    },
    computed: {
        num_slides_per_page() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs": return 2
                case "sm": return 2
                case "md": return 4
                case "lg": return 6
                default: return 6
            }
        },
        splide_options () {
            return {
                type: 'loop',
                gap: '1em',
                autoplay: true,
                interval: 10000, // milliseconds
                pauseOnHover: true,
                resetProgress: true,
                perPage: this.num_slides_per_page,
                navigation: false,
                pagination: false,
                arrows: false
            }
        },
    },
    mounted() {
        const slideContainer = this.$el.querySelector('.splideContainer');
        if (slideContainer) {
            // Use global addEventListener because some carousel elements are duplicated on the fly and don't work like normal DOM elements
            slideContainer.addEventListener('mouseover', this.handleMouseOver);
            // Display Latest shows' first item title
            const elem = this.$refs.splide1.$el.querySelector('.splide__slide.is-active img')
            this.$refs.currentShowTitle.textContent = elem.getAttribute('alt')
        }
    },
    created() {
        import('@splidejs/splide/dist/css/splide.min.css')
    },
    methods: {
        changeSrc(src) {
            this.currentSrc = src
        },
        goPrev() {
            this.$refs.splide1.go('-1')
            // Update the title of the prebious show
            let activeSlide = document.querySelector('.splide__slide.is-active');
            if(activeSlide.previousElementSibling) {
                this.$refs.currentShowTitle.textContent = activeSlide.previousElementSibling.querySelector('img').alt;
            }
        },
        goNext() {
            this.$refs.splide1.go('+1')
            // Update the title of the next show
            const elem = this.$refs.splide1.$el.querySelector('.splide__slide.is-active + .splide__slide img')
            this.$refs.currentShowTitle.textContent = elem.getAttribute('alt')
        },
        handleMouseOver(event) {
            let title = ''
            if( event.target.tagName === 'IMG' && event.target.hasAttribute('alt') ) {
                title = event.target.getAttribute('alt')
            }
            if (title) {
                this.$refs.currentShowTitle.textContent = title
            }
        },
        underConstruction() {
            this.$root.snackbar.warning('Website Under Construction')
        }

    }
}
</script>

<style scoped>
.carousel-image {
    width: 100%;
    height: auto;

}
.websites-section a {
    width: fit-content;
    font-size: 33px;
    font-weight: 300;
}
.current_show_title {
    height: 38px;
}
</style>

